import axios, { InternalAxiosRequestConfig } from 'axios';
import { makeAnalyticsInterceptor } from '@carvana/stc-utilities';
import { authenticatedAxios } from './axios';

type AxiosInterceptor = (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig;

const CARVANA_URL_BASE = process.env.CARVANA_APP_BASE_URL ?? '';
const VERSION = process.env.APP_VERSION ?? '';
const TRADES_API = process.env.CARVANA_APP_TRADES_API ?? '';
const USER_ORCHESTRATOR = process.env.CARVANA_APP_USER_ORCHESTRATOR_API ?? '';
const USER_ACCOUNT = `${process.env.CARVANA_APP_API_BASE ?? ''}/user-account`;
const CARVANA_APP_BFF_API = process.env.CARVANA_APP_BFF_API ?? '';

const analyticsHeaders = () => {
  // Only set up interceptors in the browser, not during server-side build
  if (typeof window !== 'undefined') {
    axios.interceptors.request.use(
      makeAnalyticsInterceptor({
        allowedUrls: [
          TRADES_API,
          CARVANA_URL_BASE,
          USER_ORCHESTRATOR,
          USER_ACCOUNT,
          CARVANA_APP_BFF_API
        ],
        appVersion: VERSION
      }) as AxiosInterceptor
    );
    authenticatedAxios.interceptors.request.use(
      makeAnalyticsInterceptor({ allowedUrls: ['/'], appVersion: VERSION }) as AxiosInterceptor
    );
  }
};

analyticsHeaders();
